import React from 'react';
import SetupConnectObjectPage from './SetupConnectObjectPage';

const SetupSecurityProfilePage = () => (
  <SetupConnectObjectPage
    pageTitle="Setup Security Profile"
    pageSubtitle="Upload JSON to create security profiles for a selected Amazon Connect instance"
    objectLabel="Security Profile"
    endpointKey="securityProfileApi"
    presignType="security-profile"
    sampleFile="sample_security_profile_upload.json"
    acceptedKeys={["security_profiles", "items"]}
    requiredFields={["SecurityProfileName", "Permissions"]}
  />
);

export default SetupSecurityProfilePage;
